import { ControlFacet } from '../models/controls/ControlFacet';

export const invokeActionControl = new ControlFacet<{
  itemKey: string;
}, {
    action: JSX.Element | null;
  }>('invokeActionControl');
